import { Phone, Clock, Wrench, ShieldCheck } from "lucide-react";
import { STATS, SITE } from "@/lib/siteConfig";

const STEPS = [
  { icon: Phone, title: "01 · Vous appelez", text: "Un technicien décroche en moins d'une sonnerie et évalue votre situation." },
  { icon: Wrench, title: "02 · Devis immédiat", text: "Tarif clair annoncé au téléphone. Aucune mauvaise surprise à l'arrivée." },
  { icon: Clock, title: "03 · Intervention rapide", text: "Technicien sur place en moins de 30 min, 7j/7, 24h/24." },
  { icon: ShieldCheck, title: "04 · Garantie 2 ans", text: "Pièces certifiées A2P, main-d'œuvre garantie et facture assurance." },
];

export default function Trust() {
  return (
    <section id="trust" data-testid="trust-section" className="relative bg-[#0A0A0A] text-white overflow-hidden reveal">
      {/* Background image */}
      <div className="absolute inset-0 opacity-20">
        <img
          src="https://images.unsplash.com/photo-1759452003649-552896c8ed63?crop=entropy&cs=srgb&fm=jpg&w=1920&q=80"
          alt=""
          className="w-full h-full object-cover"
          aria-hidden="true"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0A0A0A] via-[#0A0A0A]/90 to-[#0A0A0A]/70" />
      </div>
      <div className="grain absolute inset-0" />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 sm:py-28 lg:py-32">
        <div className="grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5">
            <div className="text-xs tracking-[0.25em] uppercase font-bold text-red-400 mb-4">
              — Pourquoi nous choisir
            </div>
            <h2 className="font-display font-black tracking-tighter text-4xl sm:text-5xl lg:text-6xl uppercase leading-[0.95]">
              Transparence,<br />
              <span className="text-red-500">rapidité,</span><br />
              sérieux.
            </h2>
            <p className="mt-6 text-slate-300 text-lg leading-relaxed max-w-md">
              Parce qu'une urgence serrurerie ne doit jamais devenir une arnaque.
              Chaque intervention suit un protocole strict, du premier appel à la facture.
            </p>
            <a
              href={SITE.phoneHref}
              data-testid="call-cta-trust"
              className="mt-8 inline-flex items-center gap-3 bg-red-600 hover:bg-red-700 text-white px-6 py-4 font-display font-bold uppercase tracking-tight transition-all shadow-[0_4px_0_#991B1B] hover:shadow-[0_2px_0_#991B1B] hover:-translate-y-0.5"
            >
              <Phone className="w-5 h-5" strokeWidth={2.5} />
              Appeler maintenant
            </a>
          </div>

          <div className="lg:col-span-7">
            {/* Stats row */}
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-px bg-white/10 mb-12">
              {STATS.map((s) => (
                <div key={s.label} className="bg-[#0A0A0A] p-5 sm:p-6">
                  <div className="font-display font-black text-3xl sm:text-4xl text-white tracking-tighter">
                    {s.value}
                  </div>
                  <div className="text-[11px] uppercase tracking-[0.15em] text-slate-400 mt-2 font-bold">
                    {s.label}
                  </div>
                </div>
              ))}
            </div>

            {/* Steps */}
            <div className="grid sm:grid-cols-2 gap-5">
              {STEPS.map((step) => {
                const Icon = step.icon;
                return (
                  <div key={step.title} className="group border border-white/10 p-6 hover:border-red-500/50 hover:bg-white/5 transition-all">
                    <Icon className="w-7 h-7 text-red-500" strokeWidth={2} />
                    <div className="mt-5 font-display font-bold text-lg uppercase tracking-tight">
                      {step.title}
                    </div>
                    <p className="mt-2 text-sm text-slate-400 leading-relaxed">
                      {step.text}
                    </p>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
